import { render, staticRenderFns } from "./WeeklyLog.vue?vue&type=template&id=ffdd28d2&scoped=true&"
import script from "./WeeklyLog.vue?vue&type=script&lang=js&"
export * from "./WeeklyLog.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyLog.vue?vue&type=style&index=0&id=ffdd28d2&prod&lang=scss&"
import style1 from "./WeeklyLog.vue?vue&type=style&index=1&id=ffdd28d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdd28d2",
  null
  
)

export default component.exports